import axios from "@/utils/axios";

export default async function (city: any) {
  const response = await axios.get(`/cities/${city}/neighborhood`);

  const neighborhoods = response.data;

  return neighborhoods;
}
